import React from "react";
import { useTranslation } from "react-i18next";
import UserAvatar from "app/components/UserAvatar";
import styles from "./styles.module.scss";

interface Props {
  coaches: any[];
  onSelect: (coach: any) => void;
}

const CoachList = ({ coaches, onSelect }: Props) => {
  const { t } = useTranslation();

  if (coaches.length === 0) {
    return <p className={styles.empty_state}>{t("No coaches available")}</p>;
  }

  return (
    <div className={styles.list}>
      {coaches.map((coach) => (
        <div
          key={coach.id}
          className={styles.list_row}
          onClick={() => onSelect(coach)}
        >
          <UserAvatar
            userName={`${coach.firstName} ${coach.lastName}`}
            srcName={coach.profilePicture}
            className={styles.coach_avatar}
          />
          <span className={styles.list_row_name}>
            {coach.firstName} {coach.lastName}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CoachList;
